import Vue from "@/main";
import { connection } from "./jsstore_con";
import { ChatTicketService } from "./chatTicket_service";
import { CustomerGroupService } from "./customerGroup_service";

export class CustomerService {
    constructor() {
        this.tableName = "Customer";
        this.ctService = new ChatTicketService();
        this.cgService = new CustomerGroupService();
    }

    async insert(value) {
        if ( value.group_of_customer && value.group_of_customer.length > 0 ) {
            await this.cgService.insert(value.group_of_customer);
        }

        let clearedCustomer = this.cleanPhoneNumber(value)
        await connection.insert({
            into: this.tableName,
            values: [clearedCustomer],
            upsert: true
        });
    }
    
    cleanPhoneNumber(customer) {
        let cust = JSON.parse(JSON.stringify(customer))
        cust.phone_number = cust.phone_number.replace(/[^0-9]+/g,'');
        return cust;
    }
    
    async update(value, refresh = false, refreshInChat = false, openTickets = []) {
        if ( value.group_of_customer && value.group_of_customer.length > 0 ) {
          await this.cgService.update(value.group_of_customer, refresh)
        } else {
          await this.cgService.remove(value.id, refresh)
        }

        let updated = await connection.update({
            in: this.tableName,
            set: {
                is_blacklisted: Number(value.is_blacklisted),
                is_favorite: Number(value.is_favorite),
                open_field: value.open_field,
                color_tag: value.color_tag,
                name: value.name,
                image: value.image,
                phone_number: value.phone_number,
                group_of_customer: value.group_of_customer
            },
            where: {
                id: value.id  
            }
        })

        if (updated === 0 && openTickets.length > 0){
            await this.ctService.findTickets(openTickets, refresh)
        }
        if (updated > 0 && refresh) {
            Vue.$events.fire('RefreshQueryObservable', false);
            if (refreshInChat){
                Vue.$events.fire('UpdateCustomerInActiveUser', value);
            }
        }
    }
    
    async getById(value) {
        return await connection.select({
            from: this.tableName,
            where: {
                id: value
            }
        })
    }

    async clearTable(instance) {
        await this.cgService.clearTable(instance)

        let ids = [];
        let cTickets = await connection.select( {
            from: 'ChatTickets',
            where: {
                instance_id: { in: instance }
            }
        })
        
        if (cTickets.length >= 1) {
            cTickets.forEach((cTicket) => {
                ids.push(cTicket.customer_id)
            })

            await connection.remove({
                from: this.tableName,
                where: {
                    id: {
                        in: ids
                    }
                }
            })
        }
    }
}
